import React, { FC } from 'react'
import classNames from 'classnames'
import { PlayIcon } from '@/atoms/Icons/PlayIcon'
import { Image } from '@/atoms/Image'
import { EyebrowSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { CRITIC_IMAGES } from '@/views/TicketCheckoutViews/ShowtimesView/components/ShowtimeDetailsPanel/ShowtimeDetailsPanel'

interface Props {
  imageUrl: string
  onClick: () => void
  className?: string
  isVerifiedHot?: boolean
}
export const VerticalTrailerPoster: FC<Props> = ({ imageUrl, onClick, className, isVerifiedHot }) => {
  const { t } = useTranslate('tickets')

  return (
    <button
      onClick={onClick}
      className={classNames(
        'relative shrink-0 cursor-pointer group focus-visible:border-black focus-visible:ring-[1px] focus-visible:ring-white rounded-[8px]',
        className,
      )}
    >
      <Image
        alt="movie thumbnail"
        className="rounded-[8px]"
        src={imageUrl}
        width={73}
        height={109}
        sizes="(max-width: 1023px) 73px, 0px"
        loading="lazy"
      />

      <div className="absolute inset-0 transition-colors duration-150 ease-in-out group-hover:bg-black/30 group-active:bg-black/50" />

      <EyebrowSM color="white" weight="semibold" className="mt-1.5 flex items-center gap-[2px]">
        <PlayIcon size={16} color="white" />
        {t('trailer', 'Trailer')}
      </EyebrowSM>

      {isVerifiedHot && (
        <Image
          alt=""
          src={CRITIC_IMAGES['VERIFIED_HOT']}
          width={24}
          height={24}
          className="absolute -right-[6px] -top-[6px]"
          sizes="24px"
          loading="lazy"
        />
      )}
    </button>
  )
}
